// Frontend mirror of backend role permissions — used ONLY for nav/UI visibility.
// The server is the real authority and re-checks every request.
const READS = new Set([
  "customers:read", "contracts:read", "documents:read", "tasks:read",
  "renewals:read", "communication:read", "reports:read", "dashboard:read",
  "ai:read", "settings:read", "wawi:read", "mobilfunk:read",
]);
const SALES = new Set([...READS, "customers:write", "contracts:write", "tasks:write",
  "communication:write", "renewals:write", "ai:use", "export", "wawi:write",
  "mobilfunk:contracts"]);
const DOCS = new Set([...READS, "documents:write", "documents:review", "tasks:write"]);
const MANAGER = new Set([...SALES, ...DOCS, "reports:export", "wawi:admin",
  "mobilfunk:write", "mobilfunk:models", "mobilfunk:import",
  "mobilfunk:approve", "mobilfunk:settle"]);
const ADMIN = new Set([...MANAGER, "settings:write", "branding:write", "modules:write",
  "users:write", "integrations:write", "ai:feedback", "audit:read",
  "mobilfunk:admin"]);

const MAP = {
  readonly: READS,
  sales: SALES,
  document: DOCS,
  manager: MANAGER,
  admin: ADMIN,
  owner: new Set([...ADMIN, "billing:write"]),
};

export function can(role, perm) {
  return MAP[role]?.has(perm) || false;
}

export const ROLE_LABELS = {
  owner: "Inhaber", admin: "Administrator", manager: "Manager",
  sales: "Vertriebsmitarbeiter", document: "Dokumentenbearbeitung", readonly: "Leser",
};
